import * as React from "react";
import * as Rest from "../../Generated/RestClient";
import { BotTab } from "../../Views/BotTab";
import { BlockRowInputTooltipDisposer, BlockRowInputLabel } from "../../Views/Shared/BlockRowInputLabel";
import { IconFile } from "./BotPage";
import { BotAppContinuousIntegration, BotAppCIState } from "./BotAppContinuousIntegration";
import {BotUtils} from "../../Utils/BotUtils";
import {KuduClient,ArmClient} from "../../Services/index";
import getBotResourceId from "../Services/botResourceId";
import { BladeType } from "../Services/azurePortalLinks";
import {getBotZipBlobUrl} from "../Services/downloadBotSrc";

export interface BotAppSettingsProps extends React.Props<BotAppSettings> {
    openBlade(bladType: BladeType): void;
    handleChange(field: string, value: string): void;
    onSave(): void;
    onDropIcon(files: IconFile[]): void;
    downloadZip(): JQueryPromise<Blob>;
    onZipDownloaded(blobUrl: string): void;
    initialBot: Rest.BotService;
    scmType: JQueryPromise<string>;
    v4UI?: boolean;
    kuduClient: JQueryPromise<KuduClient>;
    armClient: JQueryPromise<ArmClient>;
}

export interface BotAppSettingsState {
    bot?: Rest.BotService;
    botDeploymentLogFound?: boolean;
    pendingZipDownload?: boolean;
    zipBlobUrl?: string;
    scmType?: string;
}

export const defaultCIState : BotAppCIState = {
    repoProvider: 'vso',
    repoToken: '',
    repoUserName: ''
};

export class BotAppSettings extends React.Component<BotAppSettingsProps, BotAppSettingsState>
    implements BotTab {
    private prevToolTipCloser: BlockRowInputTooltipDisposer;

    constructor(props: BotAppSettingsProps) {
        super(props);
        this.state = { bot: props.initialBot };
    }

    public setBotId(botId: string) {
        // do nothing
    }

    public setBot(bot: Rest.BotService) {
        this.setState({ bot: bot } as any);
    }

    private onTooltipVisibilityChanged(visible: boolean, closer: BlockRowInputTooltipDisposer) {
        if (visible) {
            if (this.prevToolTipCloser) {
                this.prevToolTipCloser();
                this.prevToolTipCloser = null;
            }
            this.prevToolTipCloser = closer;
        }
    }

    public componentWillUpdate(nextProps: BotAppSettingsProps, nextState: BotAppSettingsState)
    {
        if (nextState.scmType && this.state.scmType != nextState.scmType)
        {
            this._scmType = nextState.scmType;
        }
    }

    public componentDidUpdate(prevProps: BotAppSettingsProps, prevState: BotAppSettingsState) {
        if (this.botCI && this._scmType) {
            this.botCI.resolveScmType();
            this._scmType = null;
        }
    }

    public render(): JSX.Element {
        return this.renderAzureSettings();
    }

    private get isABSv1Bot() : boolean {
        return BotUtils.isABSv1Bot(this.state.bot)  && !BotUtils.isABSCodeBot(this.state.bot);
    }

    private _scmType: string;
    private get scmType() : JQueryPromise<string> {
        return this._scmType ? $.Deferred<string>().resolve(this._scmType) : this.props.scmType;
    }
    
    private botCI : BotAppContinuousIntegration;

    private showFunctionEditor = false;
    private debugContinuousIntegration = false;
    private renderAzureSettings(): JSX.Element {

        return (
            <div className="bot-app-settings">
                {
                    this.isABSv1Bot || this.debugContinuousIntegration ?
                    (<BotAppContinuousIntegration
                        openBlade={blade => this.props.openBlade(blade) }
                        downloadZip={this.props.downloadZip}
                        bot={this.state.bot}
                        scmType={() => this.scmType}
                        bladeUrl={() => $.Deferred<string>().resolve('')}
                        botDeploymentLogFound={this.state && this.state.botDeploymentLogFound}
                        pendingDownload={this.state && this.state.pendingZipDownload}
                        blobUrl={getBotZipBlobUrl(this.state.bot ? this.state.bot.Id : null, this.state.zipBlobUrl)}
                        onZipDownloaded={this.props.onZipDownloaded}
                        kuduClient={() => this.props.kuduClient}
                        armClient={() => this.props.armClient}
                        botRsrcId={$.Deferred<string>().resolve(getBotResourceId(this.state.bot))}
                        toggleTip={null}
                        ref={x => this.botCI = x}
                        />)
                    : null
                }
                {
                    this.isABSv1Bot && this.showFunctionEditor ?
                    (<section className="bot-app-setting">
                        <div className="header">
                            <h3>Edit as Azure function</h3>
                            <p>Open bot code as Azure function (experimental)</p>
                        </div>
                        <button className="default-button"
                            onClick={() => this.props.openBlade(BladeType.functionEditor)}
                        >Open</button>
                     </section>
                    )
                    : null
                }
                <section className="bot-app-setting">
                    <div className="header">
                        <h3>Application settings</h3>
                        <p>Manage environment variables and connection strings for your bot app.</p>
                    </div>
                    <button className="light-button" onClick={() => this.props.openBlade(BladeType.webConfig) }>Open</button>
                </section>
                <section className="bot-app-setting">
                    <div className="header">
                        <h3>Advanced settings</h3>
                        <p>Manage your bot like any other App Service instance.</p>
                    </div>
                    <button className="light-button" onClick={() => this.props.openBlade(BladeType.appSettings) }>Open</button>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./Client/v4/Views/BotAppSettings.tsx